import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { CollapsedMenu } from '~/src/components/Header/styled';
import { breakpoints } from '~/src/components/Header/styled';

export const Button = styled(StyledButton)`
    width: auto;
    align-self: center;
    min-width: 138px;
    padding: 11px 16px;
    font-size: 14px;
    line-height: 1.29;
    border: none;

    &:hover {
        border: none;
    }
`;

export const Profile = styled.a`
    margin-right: 44px;
    align-self: center;
    font-size: 14px;
    color: ${COLORS.black};
    position: relative;
    padding-right: 6px;
    transition: color 0.3s ease;

    @media (max-width: ${breakpoints.desktop}) and (min-width: ${breakpoints.sDesktop}) {
        margin-right: 10px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-right: 0;
        font-size: 10px;
        line-height: 1.2;
    }
    
    &:hover {
        color: ${COLORS.red};
    }
    
    &:after {
        position: absolute;
        right: -20px;
        top: -2px;
        content: '';
        width: 18px;
        height: 18px;
        background: url('${require('~/static/images/menu/auth.svg')}') no-repeat;
        background-size: cover;
        
        @media (max-width: ${breakpoints.desktop}) and (min-width: ${breakpoints.sDesktop}) {
            display: none;
        }

        @media (max-width: ${breakpoints.mobile}) {
            display: none;
        }
    }
`;

export const ProfileAuth = styled.div`
  position: relative;
  transition: 0.3s color ease;
  cursor: pointer;
  flex-wrap: nowrap;
  
  &:hover {
    color: ${COLORS.red};
  }
  
  &:hover>div {
    height: auto;
    display: flex;
    padding: 22px 16px 16px;
  }
`;

export const Name = styled.span`
    align-self: center;
    padding-right: 12px;
    font-size: 14px;
    white-space: nowrap;

    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;

export const Avatar = styled.span`
    align-self: center;
    background: ${COLORS.red};
    color: ${COLORS.white};
    font-size: 12px;
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 100%;
`;

export const RightCollapsedMenu = styled(CollapsedMenu)`
    white-space: nowrap;
    flex-direction: column;
    align-items: flex-end;
    left: auto;
    right: -16px;
    transform: translate(0, 0);
    font-size: 12px;
    
    a, span {
        color: ${COLORS.black};
        transition: color 0.3s ease;
        
        &:hover {
            color: ${COLORS.red};
        }
    }
`;

export const HideOnMobile = styled.div`
    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;
